<template>
    <div class="grid justify-items-stretc">
        <div class="flex items-center justify-between pt-8  px-6">
            <span class="flex items-center ">
                <SchedulerInfoIcon class="mr-2"/>
                Schedule Info
            </span>
            <Arrow/>
        </div>
        <div class="m-6 p-6 bg-white rounded-lg lg:flex flex-wrap">
           <div class="w-full lg:w-5/12 mb-6 lg:mb-0">
                <span class=" text-payneFire font-semibold text-sm mb-5">Status</span>
                <BadgeStatus :status="post.state" class="mt-3"/>
           </div>
            
           <div class="w-full lg:w-7/12">
               <span class="text-payneFire font-semibold text-sm mb-5">Post Date</span>
               <DatePickerInput @dateChanged="changeDate" :initialDate="getDateWithTime()" :fromToday="true" v-if="!posted" class="mt-3"/>
               <p v-else class="mt-3">{{getPostDate()}}</p>
           </div>
        </div>
        <button @click="updateDate" :disabled="posted" :class="saved ? 'bg-aquamarine text-white border-aquamarine': 'bg-platinumFire text-cosmosHot border-gray-200'" class="rounded-lg transition-all ease-in px-10 py-3 justify-self-end text-sm border-2 mr-6">
            <span>Save</span>
        </button>
  </div>
</template>

<script>
import DatePickerInput from "@/components/scheduler/Common/DatePickerInput";
import BadgeStatus from '@/components/scheduler/Table/Row/partials/BadgeStatus';

import SchedulerInfoIcon from '@/components/svg/SchedulerInfoIcon';
import CurvedArrow from '@/components/svg/CurvedArrow';
import dayjs from "dayjs";

var utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

export default {
    name:"SchedulerInfo",

    props: {
        post: {
            type: Object,
            required:true 
        },

        posted: {
            type: Boolean,
            required: true
        }
    },

    components: {
        SchedulerInfoIcon,
        DatePickerInput,
        CurvedArrow,
        BadgeStatus
    },

    data() {
        return {
            postDate: '',
            saved: false
        }
    },

    methods: {
        getPostDate() {
            return dayjs(this.post.post_date).format('dddd, MMMM DD, YYYY');
        },

        getDateWithTime() {
            var clientTimezoneOffset = -(new Date().getTimezoneOffset()/60);
      
            return this.post.post_date ? dayjs(this.post.post_date).add(clientTimezoneOffset, 'hour') : '';
        },

        updateDate() {
            this.saved=false;
            this.$inertia.put(this.$route('scheduler.posts.update', { postId: this.post.id }), {'post_date': this.postDate},
            {
                preserveScroll: true
            });
        },

        changeDate(postingDate) {
            this.saved=true;
            this.postDate = postingDate;
        },
    }
}
</script>